import React from "react";
import {
    Dialog,
    DialogHeader,
    DialogContent,
    Button,
    Inline,
    FormControl,
    Input,
    Banner,
  } from "@airbus/components-react";
  import GlobalWPUser from "../models/WPUser";
  import WPCalendarEvent from "../models/WPCalendarEvent";
  import eventBus from "../eventBus/EventBus";


  class EventLocationCreateForm extends React.Component {

    /*************/
    /*CONSTRUCTOR*/ 
    /*************/
    constructor(props) {
        super()

        this.WPCalendarEvent = new WPCalendarEvent();

         //States
        this.state={
            form:{
                venue: '',
                address: '',
                zip: '',
                city: ''
            },
            open: true,            //on true open modal box
            notification: false,
            location_reload : false,    //If true will reload list of locations once modal box is closed
            windowWidth: window.innerWidth,     //screen width 
            windowHeight: window.innerHeight,   //screen height
        }


        //Notifications properties
        this.notifVariant = null;
        this.notifMessage = null;
        this.notifDescription = null;



    }


    componentDidUpdate = () => {
      
        window.addEventListener("resize", this.handleResize);
    }

    /*Handle screen size*/
    handleResize = (e) => {
      
        //debugger;
        this.setState({ 
            windowWidth: window.innerWidth,
            windowHeight: window.innerHeight
        });
    
    };



    /*************/
    /*RENDERING*/ 
    /*************/
    render(){
        return(
            <div>
                <Dialog className={"EventLocationModalBox"} open={this.state.open} onClose={this.onCloseModal} >
                    <DialogHeader>Nouveau Lieu</DialogHeader>
                
                    <DialogContent >

                            {/* Notification*/}
                            {this.state.notification ?
                               <div style={{position:"fixed", width:this.state.windowWidth-90, zIndex:1000}}>
                               <Banner style={{display:this.state.notification}} variant={this.notifVariant} autoHideDuration={3000}  onClose={() => this.toggleNotif(false)}>
                                   <div>
                                   <p>{this.notifMessage}</p>
                                   {this.notifDescription !== null ?
                                   <p>{this.notifDescription}</p>
                                   :null}
                                   </div>
                               </Banner>
                               <p></p>
                               </div>
                            :null}

                            <Inline spacing="2-x" align="left" >
                                {/*NAME*/}
                                <FormControl
                                    error={!this.venueValid()}
                                    errorText="Obligatoire"
                                    label="Nom du lieu"
                                    placeholder="Nom du lieu"
                                    required
                                    style={{height:100, width:300}}
                                >
                                    <Input value={this.state.form.venue} onChange={this.onChangeVenue} />
                                </FormControl>
                            </Inline>

                            <Inline spacing="2-x" align="left" >
                                {/*ADDRESS*/}
                                <FormControl
                                    label="Adresse"
                                    placeholder="Adresse"
                                    required
                                    style={{height:100, width:300}}
                                >
                                    <Input value={this.state.form.address} onChange={this.onChangeAddress} />
                                </FormControl>
                            </Inline>

                            <Inline spacing="2-x" align="left" >
                                {/*POST CODE*/}
                                <FormControl
                                    label="Code postal"
                                    placeholder="Code postal"
                                    required
                                    style={{height:100}}
                                >
                                    <Input value={this.state.form.zip} onChange={this.onChangeZip} />
                                </FormControl>
                            </Inline>

                            <Inline spacing="2-x" align="left" >
                                {/*VILLE*/}
                                <FormControl
                                    label="Ville"
                                    placeholder="Ville"
                                    required
                                    style={{height:100, width:300}}
                                >
                                    <Input value={this.state.form.city} onChange={this.onChangeCity} />
                                </FormControl>
                            </Inline>

                             {/*SUBMIT*/}
                            <Inline spacing="3-x" align="center" >
         
                                <Button variant="primary" 
                                                onClick = {this.onCreateVenueSubmit}
                                                disabled = {!this.venueValid() 
                                                    }
                                                style={{
                                                    width: "100%"
                                                    }}>
                                                CREER NOUVEAU LIEU
                                </Button>
                            </Inline>
                       
                        
                    </DialogContent>
                
                </Dialog>
            </div>
        )}

    /*************/
    /*EVENTS      */ 
    /*************/
    
    //Vérification Nom du lieu
    venueValid = () => {
        return this.state.form.venue !== undefined && this.state.form.venue.length > 0;
    };

     //Venue Input Change handler
     onChangeVenue = (event) => {
         
        let formData = this.state.form;
        formData.venue = event.target.value;
        
        this.setState({form:formData});
         
    }

    //Address Input Change handler
    onChangeAddress = (event) => {
         
        let formData = this.state.form;
        formData.address = event.target.value;
        
        this.setState({form:formData});
         
    }

    //ZIP Input Change handler
    onChangeZip = (event) => {
         
        let formData = this.state.form;
        formData.zip = event.target.value;
        
        this.setState({form:formData});
         
    }

    //City Input Change handler
    onChangeCity = (event) => {
         
        let formData = this.state.form;
        formData.city = event.target.value;
        
        this.setState({form:formData});
         
    }
    
    onCloseModal = () =>{

        this.setState({open:false});
        eventBus.dispatch("event_modal_location_close", {   event_modal_location_close: true,
                                                            event_location_reload : this.state.location_reload });

    }

    //Submit
    onCreateVenueSubmit = async (event) =>{

        let formData = this.state.form;

        let response = await this.WPCalendarEvent.addCalendarVenue(
                                                                    formData.venue,
                                                                    formData.address,
                                                                    formData.zip,
                                                                    formData.city
                                                                    );
        
        //Authenticate error ?
        if(GlobalWPUser.user_error.status){
            this.notifVariant = "error";
            this.notifMessage = GlobalWPUser.user_error.status + ": "+GlobalWPUser.user_error.code;
            this.notifDescription = GlobalWPUser.user_error.message;
            this.setState({notification:true});

        }

        //API CALL Error ?
        else if (response === undefined || response === null){
            this.notifVariant = "error";
            this.notifMessage = "Erreur lors de la création du lieu";
            this.setState({notification:true});

        }else if(this.WPCalendarEvent.WPCalendarError.status !== null) {
            //API call failed
            this.notifVariant = "error";
            this.notifMessage = "Erreur lors de la création du lieu";
            this.notifDescription = this.WPCalendarEvent.WPCalendarError.status+": "+this.WPCalendarEvent.WPCalendarError.message
            this.setState({notification:true});
        }
        else{
            //ALL is OK
            this.notifVariant = "success";
            this.notifMessage = "Lieu créé avec succès";
            this.setState({notification:true});
            this.setState({location_reload:true});
        }
    }

    //fire / close notification
    toggleNotif(val) {
        this.setState({
            notification: val
        });
      }
       

  }

  

  export default EventLocationCreateForm;